import { publisherPermission, settingsPermission } from "../app/constants"
import { useRole } from "../app/services/user"
import { useDocumentListLocales } from "./useDocumentListLocales"

export function useHasSettingsPermission() {
  const { role } = useRole()
  return settingsPermission[role]
}

export function useHasPublisherPermission() {
  const role = useRoleFromLocale()
  return publisherPermission[role]
}

function useRoleFromLocale() {
  const { locale } = useDocumentListLocales()
  const { role } = useRole(locale)

  return role
}
